import React, { FC } from "react";
import { Suspense } from "react";
import { ErrorBoundary } from "../../../Common/ErrorBoundry";
import { Window } from "@progress/kendo-react-dialogs";
import { useReduxSelector } from "../../../../redux/hooks";


const LiveTicketView: FC = () => {
    //const {} = useReduxSelector((state) => state);
    //@ts-expect-error
    const TicketView = React.lazy(() => import("chat/TicketView"));

    return (
        <ErrorBoundary>
            <div className="live-ticket-view-bar">
                <Suspense fallback={null}>
                    <TicketView />
                </Suspense>
            </div>
        </ErrorBoundary>
    )
}

export default LiveTicketView;